module.exports = __webpack_public_path__ + "img/4456f84.png";